import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-outlined-close-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16992 14.8299L14.8299 9.16992"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M14.8299 14.8299L9.16992 9.16992"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class OutlinedCloseIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
  override fill = input<string>('none');
  override color = input<string>('#EF4444');
  override width = input<string>('24');
  override height = input<string>('24');
}
